export default "__VITE_ASSET__b16HK_la__"